/**
 * Legacy-parity hover behavior for the PDP cross-product color-swatch
 * switcher (blocks/_pdp-color-swatches.liquid): swaps the "Color: [name]"
 * label to the hovered swatch's color, reverting on mouseleave. Scoped via
 * this.querySelectorAll (not document.querySelectorAll) so multiple
 * instances on one page - e.g. a quick-view duplicate - don't collide.
 */
class PdpColorSwatches extends HTMLElement {
  connectedCallback() {
    this._label = this.querySelector('.swatch-current-color');
    this._labelEl = this.querySelector('.swatch-label');
    if (!this._label || !this._labelEl) return;

    this._defaultColor = this._labelEl.dataset.currentColor || this._label.textContent;

    this.querySelectorAll('.swatch-grid__item').forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => {
        const color = swatch.dataset.color;
        if (color) this._label.textContent = color;
      });
      swatch.addEventListener('mouseleave', () => {
        this._label.textContent = this._defaultColor;
      });
    });
  }
}

if (!customElements.get('pdp-color-swatches')) {
  customElements.define('pdp-color-swatches', PdpColorSwatches);
}
